import React from "react";
import Navbar from "../component/Navbar";
import EatImages from "../component/EatImages";
import Footer from "../component/Footer";

function WhatToEat() {
	return (
		<div>
			<Navbar />
			<div
				className="container"
				id="what-to-eat"
			>
				<h2 className="text-center mt-5">What to eat</h2>
				<div className="row mt-5">
					<div className="col-sm-6">
						<h3 className="mb-3">Good food good mood</h3>
						<p>
							<strong>Apochti: </strong>This local delicacy is cured pork loin,
							it is first salted then placed in vinegar and then finally air
							dried. <br />
							<br />
							<strong> Domatokeftedes:</strong> Aka tomato fritters. Santorini
							is known for its variety of tomatoes and this delicious dish makes
							the perfect snack. <br />
							<br />
							<strong>Fava:</strong> Fava is the name for split peas in Greece.
							The famous Santorini fava is served in two ways: cooked to creamy
							perfection with olive oil, crushed onion, and capers sprinkled on
							top. <br />
							<br />
							<strong>Fresh seafood: </strong> Santorini is known for its fresh
							seafood so definitely indulge in all Santorini has to offer.
							<br />
							<br />
							<strong>Greek wine:</strong> It's made from grapes so perhaps this
							still counts? Greece is known as a top Mediterranean wine
							producing nation, be sure to try all the wine (if possible!) and
							visit Santo Wines. <br />
							<br />
							<strong>Saganaki:</strong> This local staple is perfect for cheese
							lovers, the cheese is pan fried until a gooey melted inside is
							achieved. <br />
							<br />
						</p>
					</div>

					<div className="col-sm-6">
						<img
							className="img-fluid"
							src="https://s3.amazonaws.com/shecodesio-production/uploads/files/000/081/895/original/wine.jpeg?1684072473"
							alt="Food and wine"
						/>
					</div>
				</div>
			</div>

			<div className="santorini-images mt-5">
				<div className="container images d-flex justify-content-around">
					<EatImages />
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default WhatToEat;
